import { render } from "./StatisticsKpi.vue?vue&type=template&id=ea2bd038&scoped=true"
import script from "./StatisticsKpi.vue?vue&type=script&lang=js"
export * from "./StatisticsKpi.vue?vue&type=script&lang=js"

import "./StatisticsKpi.vue?vue&type=style&index=0&id=ea2bd038&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea2bd038"]])

export default __exports__